import type { FC, SVGProps } from 'react';

export const iconIds = [
  'arrow-left',
  'arrow-right',
  'article',
  'calendar',
  'case study',
  'course',
  'email',
  'external-tooltip',
  'facebook',
  'filters',
  'icon-cross',
  'icon-mail-footer',
  'icon-office',
  'icon-search',
  'linkedin',
  'podcast',
  'print',
  'risk-assessment',
  'toolkit',
  'twitter',
  'video',
  'video-card',
  'video-filter',
  'article-card',
  'article-filter',
  'podcast-card',
  'podcast-filter',
  'claimslesson-card',
  'casestudy-filter',
] as const;
export type IconIds = (typeof iconIds)[number];

interface IconProps extends SVGProps<SVGSVGElement> {
  icon: IconIds;
  size?: number;
}

const Icon: FC<IconProps> = ({ icon, size = 24, ...props }) =>
  iconIds.includes(icon) ? (
    <svg width={size} height={size} role="img" aria-label={icon} {...props}>
      <use href={`/icons/sprites.svg#${icon}`} />
    </svg>
  ) : null;

export default Icon;
